import React, { useEffect, useMemo, useState } from "react";
import { db } from "../firebase";

import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  query,writeBatch
} from "firebase/firestore";

import * as XLSX from "xlsx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faSearch,
  faTrash,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";

import {
  Modal,
  Box,
  Typography,
  Button,
} from "@mui/material";

import { toast } from "react-hot-toast";

interface SerialNumber {
  id: string;
  productId: string;
  point: string;
}

const SerialNumber: React.FC = () => {
  const [rows, setRows] = useState<SerialNumber[]>([]);

  const [loading, setLoading] = useState(true);

  const [searchQuery, setSearchQuery] = useState("");

  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [deleteId, setDeleteId] = useState<string | null>(null);
const [openDeleteAllModal, setOpenDeleteAllModal] = useState(false);
  const fetchSerials = async () => {
    setLoading(true);

    try {
      const q = query(collection(db, "SerailNumber"));

      const snap = await getDocs(q);

      const result: SerialNumber[] = [];

      snap.forEach((docSnap) => {
        result.push({
          id: docSnap.id,
          ...(docSnap.data() as Omit<SerialNumber, "id">),
        });
      });

      setRows(result);
    } catch (error) {
      console.error("Error fetching serials:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSerials();
  }, []);

  const filteredRows = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();

    if (!q) return rows;

    return rows.filter((row) => {
      return (
        (row.id ?? "").toLowerCase().includes(q) ||
        (row.productId ?? "").toLowerCase().includes(q) ||
        (row.point ?? "").toLowerCase().includes(q)
      );
    });
  }, [rows, searchQuery]);

  const handleExcelUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];

    if (!file) return;

    try {
      const data = await file.arrayBuffer();

      const workbook = XLSX.read(data);

      const sheetName = workbook.SheetNames[0];

      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json<any>(worksheet);

      let addedCount = 0;

      let duplicateCount = 0;

      const uploadPromises = [];

      for (const row of jsonData) {
        const serial = String(row["serial"] ?? "").trim();

        const productId = String(row["productId"] ?? "").trim();

        const point = String(row["point"] ?? "").trim();

        if (!serial) continue;

        // السيريال نفسه document id
        const serialRef = doc(db, "SerailNumber", serial);

        // فحص هل موجود
        const existingDoc = await getDoc(serialRef);

        // إذا موجود تجاهله
        if (existingDoc.exists()) {
          duplicateCount++;
          continue;
        }

        uploadPromises.push(
          setDoc(serialRef, {
            productId,
            point,
          })
        );

        addedCount++;
      }

      await Promise.all(uploadPromises);

      toast.success(
        `تم رفع ${addedCount} سيريال جديد وتجاهل ${duplicateCount} مكرر`
      );

      fetchSerials();

      event.target.value = "";
    } catch (error) {
      console.error("Excel upload error:", error);

      toast.error("حدث خطأ أثناء رفع ملف الإكسل");
    }
  };

  const handleOpenDelete = (id: string) => {
    setDeleteId(id);

    setOpenDeleteModal(true);
  };

  const handleCloseDelete = () => {
    setDeleteId(null);

    setOpenDeleteModal(false);
  };

  const handleDelete = async () => {
    if (!deleteId) return;

    try {
      await deleteDoc(doc(db, "SerailNumber", deleteId));

      toast.success("تم حذف السيريال بنجاح");

      handleCloseDelete();

      fetchSerials();
    } catch (error) {
      console.error(error);

      toast.error("حدث خطأ أثناء حذف السيريال");
    }
  };


  const handleDeleteAll = async () => {
  try {
    const snapshot = await getDocs(
      collection(db, "SerailNumber")
    );

    if (snapshot.empty) {
      toast.error("لا توجد سيريلات للحذف");
      return;
    }

    const batch = writeBatch(db);

    snapshot.forEach((docSnap) => {
      batch.delete(docSnap.ref);
    });

    await batch.commit();

    toast.success("تم حذف جميع السيريلات بنجاح");

    setOpenDeleteAllModal(false);

    fetchSerials();
  } catch (error) {
    console.error(error);

    toast.error("حدث خطأ أثناء حذف السيريلات");
  }
};
  return (
    <div
      className="w-full max-w-none mx-auto bg-white rounded-xl shadow-lg"
      style={{
        width: 1400,
        direction: "rtl",
      }}
    >
      <div className="max-w-full flex items-center justify-between bg-[#262d34] text-white px-6 py-3 rounded-t-lg shadow-md">
        <h1
          className="text-xl font-bold flex-1 text-right"
          style={{
            fontFamily: "Tajawal, sans-serif",
          }}
        >
          Serial Number
        </h1>

        <div className="flex items-center gap-3">
            <Button
  variant="contained"
  color="error"
  onClick={() => setOpenDeleteAllModal(true)}
  sx={{
    fontFamily: "Tajawal, sans-serif",
  }}
  startIcon={<FontAwesomeIcon icon={faTrash} />}
>
  حذف جميع السيريلات
</Button>
          <label>
            <input
              type="file"
              accept=".xlsx,.xls"
              hidden
              onChange={handleExcelUpload}
            />

            <Button
              variant="contained"
              component="span"
              sx={{
                fontFamily: "Tajawal, sans-serif",
                backgroundColor: "#0f766e",
              }}
              startIcon={
                <FontAwesomeIcon icon={faUpload} />
              }
            >
              رفع Excel
            </Button>
          </label>

          <div className="flex items-center bg-gray-100 rounded-full px-4 py-1 w-80 shadow-md">
            <FontAwesomeIcon
              icon={faSearch}
              className="text-gray-500 ml-2"
            />

            <input
              type="text"
              placeholder="البحث بالسيريال أو المنتج أو النقاط..."
              className="bg-transparent focus:outline-none w-full text-sm text-gray-700 py-1"
              style={{
                fontFamily: "Tajawal, sans-serif",
                textAlign: "right",
              }}
              value={searchQuery}
              onChange={(e) =>
                setSearchQuery(e.target.value)
              }
            />
          </div>
        </div>

        <Modal
  open={openDeleteAllModal}
  onClose={() => setOpenDeleteAllModal(false)}
>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 420,
      bgcolor: "white",
      borderRadius: "12px",
      boxShadow: 24,
      p: 3,
      direction: "rtl",
    }}
  >
    <Typography
      variant="h6"
      sx={{
        textAlign: "center",
        mb: 2,
        fontFamily: "Tajawal, sans-serif",
        fontWeight: "bold",
        color: "red",
      }}
    >
      حذف جميع السيريلات
    </Typography>

    <Typography
      sx={{
        textAlign: "center",
        mb: 3,
        fontFamily: "Tajawal, sans-serif",
      }}
    >
      هل أنت متأكد من حذف جميع السيريلات؟
      <br />
      لا يمكن التراجع عن هذه العملية.
    </Typography>

    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: 10,
      }}
    >
      <Button
        variant="contained"
        color="error"
        onClick={handleDeleteAll}
        sx={{
          fontFamily: "Tajawal, sans-serif",
        }}
      >
        حذف الجميع
      </Button>

      <Button
        variant="outlined"
        onClick={() =>
          setOpenDeleteAllModal(false)
        }
        sx={{
          fontFamily: "Tajawal, sans-serif",
        }}
      >
        إلغاء
      </Button>
    </div>
  </Box>
</Modal>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          padding: "16px 24px",
          fontFamily: "Tajawal, sans-serif",
        }}
      >
        <div
          style={{
            background: "#f1f5f9",
            border: "1px solid #e2e8f0",
            borderRadius: "12px",
            padding: "14px 22px",
            minWidth: "220px",
            textAlign: "center",
            boxShadow:
              "0 2px 8px rgba(0,0,0,0.06)",
          }}
        >
          <div
            style={{
              fontSize: 14,
              color: "#64748b",
              marginBottom: 6,
            }}
          >
            مجموع السيريلات
          </div>

          <div
            style={{
              fontSize: 28,
              fontWeight: "bold",
              color: "#0f766e",
            }}
          >
            {rows.length}
          </div>
        </div>
      </div>

      {loading ? (
        <p
          style={{
            padding: 20,
            fontFamily: "Tajawal, sans-serif",
          }}
        >
          جاري التحميل...
        </p>
      ) : (
        <div
          className="table-container"
          style={{ overflowX: "auto" }}
        >
          <table
            className="product-table"
            style={{ width: "100%" }}
          >
            <thead className="color-table">
              <tr>
                <th>#</th>

                <th>Serial</th>

                <th>Product ID</th>

                <th>Point</th>

                <th>الإجراءات</th>
              </tr>
            </thead>

            <tbody>
              {filteredRows.map((row, index) => (
                <tr key={row.id}>
                  <td>{index + 1}</td>

                  <td style={{ fontSize: 15 }}>
                    {row.id}
                  </td>

                  <td style={{ fontSize: 15 }}>
                    {row.productId}
                  </td>

                  <td style={{ fontSize: 15 }}>
                    {row.point}
                  </td>

                  <td>
                    <div className="icon-container">
                      <button
                        className="icon-button"
                        onClick={() =>
                          handleOpenDelete(row.id)
                        }
                        title="حذف"
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ color: "red" }}
                        />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}

              {filteredRows.length === 0 && (
                <tr>
                  <td
                    colSpan={5}
                    style={{
                      textAlign: "center",
                      padding: 20,
                    }}
                  >
                    لا توجد بيانات
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <Modal
        open={openDeleteModal}
        onClose={handleCloseDelete}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform:
              "translate(-50%, -50%)",
            width: 400,
            bgcolor: "white",
            borderRadius: "12px",
            boxShadow: 24,
            p: 3,
            direction: "rtl",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              mb: 2,
              fontFamily:
                "Tajawal, sans-serif",
            }}
          >
            تأكيد الحذف
          </Typography>

          <Typography
            sx={{
              textAlign: "center",
              mb: 3,
            }}
          >
            هل أنت متأكد من حذف هذا السيريال؟
          </Typography>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 10,
            }}
          >
            <Button
              variant="contained"
              color="error"
              onClick={handleDelete}
              sx={{
                fontFamily:
                  "Tajawal, sans-serif",
              }}
            >
              حذف
            </Button>

            <Button
              variant="outlined"
              onClick={handleCloseDelete}
              sx={{
                fontFamily:
                  "Tajawal, sans-serif",
              }}
            >
              إلغاء
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default SerialNumber;